
import { Component, Prop, Vue, Watch, Emit } from "vue-property-decorator";
import Editor5 from "@/components/editor/classic-editor5.vue";
import UploadImg from "@/components/UploadImg-ai.vue";
import UploadImgV3 from "@/components/UploadImg-ai-v3.vue";
import UploadImgBefore from "@/components/UploadImg-ai.vue";
import UploadImgAfter from "@/components/UploadImg-ai.vue";
import UploadVideo from "@/components/UploadVideo-ai.vue";
import UploadVideoV3 from "@/components/UploadVideo-ai-v3.vue";
import draggable from "vuedraggable";
import RegisEdit from "../components/regis-edit.vue";
import RegisEditV3 from "../components/regis-edit-v3.vue";
import Pop from "../components/blue-pop.vue";
import ExamList from "@/lib/model/exam/exam";
import Loading from "../../../components/loading.vue";
import SW from "@/components/form/switch.vue";
import { CompanyConfig } from "@/lib/common/acm";
import mp3List from "@/lib/common/mp3";
import SetDiyPage from "../components/set-diy-page.vue";
import myCollapse from "@/views/ai-builder/step-view/components/myCollapse.vue";
import mySetup from "@/views/ai-builder/step-view/components/mySetup.vue";
import WarnDialog from "@/views/ai-builder/components/delete-dialog.vue";
import Directory from "./components/directory.vue";
import moment from "moment";

import {
  ExamV2Custom,
  RegisInfo,
  Param,
  Vir,
  BeforeVideo,
  PsycGaugeConfig
} from "@/lib/model/exambuilder/exam-v2";
import Auth from "@/lib/common/auth";
import ReportSet from "../config/reportSet.vue";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import ExamV3Custom from "@/lib/model/exambuilder/exam-v3/exam-v3";
import { SettingInformation } from "@/lib/model/exambuilder/exam-v3/exam-v3-sub";
import TimeUtil from "@/lib/common/time-util";
import { PsychologicalMotivation } from "@/lib/model/exambuilder/exam-v3/exam-v3-sub";
import { Check } from "@/lib/enum/check";

class TestExamList {
  id = 0;
  name = "";
  connectCode = "";
}

const psycGaugeIdMap = {
  [Check.BIG_FIVE_240]: 1,
  [Check.DISC]: 3,
  [Check.BIG_FIVE_60]: 4,
  [Check.DVF]: 5
};

@Component({
  components: {
    Editor5,
    UploadImg,
    UploadImgV3,
    draggable,
    RegisEdit,
    UploadVideo,
    UploadVideoV3,
    RegisEditV3,
    Pop,
    Loading,
    UploadImgBefore,
    UploadImgAfter,
    SW,
    SetDiyPage,
    myCollapse,
    ReportSet,
    mySetup,
    Directory,
    InputNumberV3,
    WarnDialog
  }
})
export default class SetOther extends Vue {
  @Prop({ type: ExamV2Custom, default: null }) exam!: ExamV2Custom; //考试Model
  @Prop({ type: ExamV3Custom, default: () => new ExamV3Custom() })
  examv3!: ExamV3Custom; //考试Model
  @Prop({ type: Boolean, default: false }) isEdit!: boolean; //是否编辑页面
  @Prop({ type: Boolean, default: false }) isCandidateUsed!: boolean; //是否已有人作答
  @Prop({}) companyPower!: any; //公司权限
  @Prop({ default: [new Vir()] }) virList!: Vir[]; //虚拟人list
  @Prop({ default: false }) setWeb!: boolean; //内部使用 web配置
  @Prop({ default: () => [new PsycGaugeConfig()] })
  mindList!: PsycGaugeConfig[]; // 心理测评list

  selectExamType(type?: string) {
    if (type === "together") {
      this.examv3.settingInformation.timeConfig.examBeginTogether = 1;
      if (
        ["", "1901-01-01 00:00:00", "0001-01-01 00:00:00"].includes(
          this.examv3.settingInformation.timeConfig.examRegisterEndTime
        )
      ) {
        this.examv3.settingInformation.timeConfig.examRegisterEndTime = this.examv3.settingInformation.timeConfig.beginTime;
      }
    } else {
      this.examv3.settingInformation.timeConfig.examBeginTogether = 2;
      this.examv3.settingInformation.timeConfig.examRegisterEndTime = "";
    }
    this.change();
  }

  get TimeUtil() {
    return TimeUtil;
  }
  // 默认文案
  get defaultText() {
    return new SettingInformation().publicityPage;
  }

  get usePublicCodeWhiteList() {
    return CompanyConfig.getInstance().usePublicCodeWhiteList === 1;
  }
  // 须知页文案中间的时间
  get TimeText() {
    let str = "";
    const sec = this.examv3.processInformation.allTestingTime;
    const m = Math.ceil(sec / 60);
    if (m >= 60) {
      const h = Math.floor(m / 60);
      str += `${h}小时`;
      const min = m % 60;
      if (min != 0) {
        str += `${min}分钟`;
      }
    } else {
      str += `${m}分钟`;
    }
    return str ? `约${str}` : "";
  }

  anchorActive = "面试设置"; //锚点
  some: any = "添加登记信息";
  phoneTop: any = 100;
  phoneBottom: any = 0;
  showMoreSetting = true; //是否展开高级设置
  hasWarnOpenJoin = false;
  showWarnDialog = false;

  deviceTestExample = require("@/assets/ai-builder/device-test-example.png");
  noiseDetectExample = require("@/assets/ai-builder/noise-detect-example.png");
  defVir = new Vir(); //旧数据 id=0 用
  mp3List = mp3List; //音色列表
  selectData = 0;
  datePickerOptions: any = {
    onPick: (obj: any) => {
      this.selectData = obj.minDate?.getTime();
      if (obj.maxDate) {
        // 第二次点击日期选择器，选好初始时间和结束时间后，解除禁用限制
        this.selectData = 0;
      }
    },
    disabledDate: (time: any) => {
      if (!this.selectData) {
        const minTime = new Date().getTime() - 3600 * 1000 * 24 * 90;
        const maxTime = new Date().getTime() + 3600 * 1000 * 24 * 90;
        return time.getTime() <= minTime || time.getTime() >= maxTime;
      } else {
        return (
          time.getTime() < this.selectData - 3600 * 1000 * 24 ||
          time.getTime() > this.selectData + 3600 * 1000 * 24
        );
      }
    }
  };

  wxBgView = require("@/assets/ai-builder/wexinbg/view.png");
  wxBgDetail = require("@/assets/ai-builder/wexinbg/detail.png");
  wxBgFailure = require("@/assets/ai-builder/wexinbg/failure.png");
  wxBgBorder = require("@/assets/ai-builder/phone-border.png");

  qrFailureText = "您好，本场面试已结束，如有问题请联系企业招聘负责人";
  showVir = false;
  showVirInfo: any = {};

  hasPower(key: string) {
    return this?.companyPower?.[key] === 1;
  }

  conut24Hours(timeStr: string, compute: string) {
    const date = new Date(timeStr);
    if (compute === "+") {
      date.setHours(date.getHours() + 24);
    } else if (compute === "-") {
      date.setHours(date.getHours() - 24);
    }

    // 获取日期和时间的各个部分
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours();
    const minutes = date.getMinutes();
    const seconds = date.getSeconds();

    // 将日期和时间的各个部分格式化为 "YYYY-MM-DD HH:MM:SS" 格式
    const result = `${year}-${month
      .toString()
      .padStart(2, "0")}-${day
      .toString()
      .padStart(2, "0")} ${hours
      .toString()
      .padStart(2, "0")}:${minutes
      .toString()
      .padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;

    return result;
  }

  checkTimeDuring(time: string, type: string, during = 24) {
    const st = this.examv3.settingInformation.timeConfig.beginTime;
    const et = this.examv3.settingInformation.timeConfig.endTime;
    if (!st || !et) {
      return;
    }
    if (
      new Date(et).getTime() - new Date(st).getTime() >
      during * 60 * 60 * 1000
    ) {
      return;
    }
    //起始时间至少间隔24小时
    // if (type === "end") {
    // }
    // if (type === "begin") {
    //   this.examv3.settingInformation.timeConfig.beginTime = this.conut24Hours(
    //     this.examv3.settingInformation.timeConfig.endTime,
    //     "-"
    //   );
    // }
    this.examv3.settingInformation.timeConfig.endTime = this.conut24Hours(
      this.examv3.settingInformation.timeConfig.beginTime,
      "+"
    );
    this.$message({
      message: "起始时间至少间隔24小时,已自动调整",
      type: "warning"
    });
  }
  setDefVir() {
    this.defVir.imgUrl =
      "https://oss.hina.com/app/test/2023/04/27/4e1887e0ceeac997ef35c0b63ae34f42.png";
    this.defVir.imgUrl2 =
      "https://oss.hina.com/app/test/2023/04/27/cfa4e88884322bba78d8a445d52b59ac.png";
    this.defVir.imgUrl3 =
      "https://oss.hina.com/app/test/2023/04/27/e2bf600dc0f075ca745d3e4eba5106eb.png";
    this.defVir.name = "小娜";
  }
  diyChange(v: BeforeVideo[]) {
    this.$set(this.exam, "examVideoList", v);
    this.change();
  }

  replaceTime(str: string) {
    return str.replace(/约\d+分钟/g, "T_I_M_E");
  }
  // 须知页文案是否为默认
  get isDefDescBeforeText() {
    const def = new ExamV3Custom().settingInformation.publicityPage.descBefore;
    const cur = this.replaceTime(
      this.examv3.settingInformation.publicityPage.descBefore
    );
    return def === cur;
  }

  setDefText(key: string) {
    this.examv3.settingInformation.publicityPage[
      key
    ] = new ExamV3Custom().settingInformation.publicityPage[key];
    if (key === "descBefore") {
      this.examv3.settingInformation.publicityPage.descBefore = this.examv3.settingInformation.publicityPage.descBefore.replace(
        "T_I_M_E",
        this.TimeText
      );
    }
  }
  selectVir(it: any) {
    this.examv3.settingInformation.virConfig.virVersion = it.id;
    this.change();
  }

  // 关闭vir视频
  closeVirVideo() {
    if (this.currentVideo) {
      this.currentVideo.removeEventListener("play", this.videoPlay);
      this.currentVideo.removeEventListener("pause", this.videoPause);
      this.currentVideo.removeEventListener("ended", this.videoPause);
    }
    this.showVir = false;
    this.currentVideo = null;
  }
  videoPlay() {
    this.showVideoPlayIcon = false;
  }
  videoPause() {
    this.showVideoPlayIcon = true;
  }
  currentVideo: HTMLVideoElement | null = null;
  showVideoPlayIcon = false;
  showVirVideo(it: any) {
    this.showVideoPlayIcon = true;
    this.showVirInfo = it;
    this.showVir = true;
    this.$nextTick(() => {
      this.currentVideo = document.getElementById("virId") as HTMLVideoElement;
      this.currentVideo.addEventListener("play", this.videoPlay);
      this.currentVideo.addEventListener("pause", this.videoPause);
      this.currentVideo.addEventListener("ended", this.videoPause);
      this.currentVideo.focus();
    });
  }
  get getVirImg() {
    return (
      this.virList.find(
        v => v.id === this.examv3.settingInformation.virConfig.virVersion
      )?.imgUrl2 || this.virHrBG
    );
  }
  playPhoneVideo = false;
  toPlayPhoneVideo() {
    this.playPhoneVideo = !this.playPhoneVideo;
    this.$nextTick(() => {
      if (this.$refs.phoneVideo) {
        this.$refs.phoneVideo[0].addEventListener("ended", () => {
          this.playPhoneVideo = false;
        });
        if (this.playPhoneVideo) {
          (this.$refs.phoneVideo[0] as HTMLVideoElement)?.play();
        } else {
          (this.$refs.phoneVideo[0] as HTMLVideoElement)?.pause();
        }
      }
    });
  }
  stopVideo() {
    if (this.playPhoneVideo) {
      this.playPhoneVideo = false;
      this.$refs.phoneVideo &&
        (this.$refs.phoneVideo[0] as HTMLVideoElement)?.pause();
    }
  }
  setSame() {
    this.examv3.settingInformation.publicityPage.descAfterShowWay = this.examv3.settingInformation.publicityPage.descBeforeShowWay;
    this.examv3.settingInformation.publicityPage.descAfterShowWayImgUrl = this.examv3.settingInformation.publicityPage.descBeforeShowWayImgUrl;
  }
  //切换展示方式
  changeShowWay(v: number, type: string) {
    if (v === 0) {
      //ai面试官朗读
      this.examv3.settingInformation.publicityPage[
        `desc${type}ShowWayImgUrl`
      ] = this.getVirImg;
    }
    if (v === 1) {
      //默认背景
      this.examv3.settingInformation.publicityPage[
        `desc${type}ShowWayImgUrl`
      ] = this.defaultBG;
    }
    if (v === 2) {
      //自定义背景
      this.examv3.settingInformation.publicityPage[
        `desc${type}ShowWayImgUrl`
      ] = this.upImgUrl[`desc${type}ShowWayImgUrl`];
    }
  }

  setSeconed() {
    this.examv3.settingInformation.timeConfig.timeLimitExam =
      this.examv3.settingInformation.timeConfig.timeLimitHours * 60 * 60 +
      this.examv3.settingInformation.timeConfig.timeLimitMinutes * 60;
    this.change();
  }
  changeVideoToDef(v: number) {
    if (v === 1) {
      this.examv3.settingInformation.publicityPage.publicityPageVideoUrl = this.videoUrlDef;
    } else if (v === 2) {
      this.examv3.settingInformation.publicityPage.publicityPageVideoUrl = this.videoUrl;
    } else {
      this.examv3.settingInformation.publicityPage.publicityPageVideoUrl = "";
    }
    this.playPhoneVideo = false;
  }

  fixedPhone = false; //手机定位
  absTop = true; //吸附上边 还是下边

  //滚动页面时，锚点跟着变化
  scrollEvent(e: any) {
    const topLimit = 64 + 53; //锚点变化时  顶部距离
    const anchorList = document.querySelectorAll(".title-lv1, .title-lv2");
    //哪个离窗口最近
    anchorList.forEach((item: any) => {
      const top = item.getBoundingClientRect().top;
      if (top === 0) return;
      if (top < topLimit) {
        this.anchorActive = item.id;
      }
    });
    if (!this.anchorActive) {
      this.anchorActive = "高级设置";
    }
    //手机定位
    const phoneBox = document.querySelector(".phone-rule-box");
    const over = document.querySelector("#高级设置");
    if (phoneBox && over) {
      const top = phoneBox.getBoundingClientRect().top;
      const bottom = over.getBoundingClientRect().top;
      //
      if (top < topLimit && bottom > 765) {
        this.fixedPhone = true;
      } else {
        this.fixedPhone = false;
        this.absTop = top < 0 ? false : true;
      }
    }
  }

  clickScrollToAnchor(anchorName: string) {
    if (anchorName) {
      const anchorElement = document.getElementById(anchorName);
      if (anchorElement) {
        // this.anchorActive = anchorName;
        anchorElement.scrollIntoView({ block: "start", behavior: "smooth" });
        // setTimeout(() => {
        //   this.anchorActive = anchorName;
        // }, 500);
      }
    }
  }

  // // 是否展示面试过期提示设置块
  // get showQrCodeFailure() {
  //   const flag = this.exam.noEnding === 2 || this.exam.timeLimitGiveUp !== -1;
  //   return flag;
  // }

  get virInfo() {
    // id为 3、4 新版直接用，
    // 1、2则转化 1 =>4， 2 =>3
    // 0旧数据用默认的defVir
    const id = this.exam.virVersion;
    const index = [3, 4].includes(id) ? id : id === 1 ? 4 : id === 2 ? 3 : 0;

    return this.virList.find(v => v.id === index) || this.defVir;
  }

  @Watch("exam", { deep: true })
  save(n: any, o: any) {
    //编辑时 数据加载完成后刷一次
    if (this.isEdit && !o.isAssigned && n.isAssigned) {
      this.setData();
      return;
    }
    this.change();
  }
  //切限制次数
  @Watch("repeatLimit", {})
  rp(n: any, o: any) {
    //不限制
    if (!n) {
      this.exam.repeatAnswerLimit = 100;
      // this.repeatLimitShow = 1;
    } else {
      //限制
      this.exam.repeatAnswerLimit = this.repeatLimitShow;
    }
  }
  //模拟练习开关
  @Watch("useTestExam", {})
  te(n: any, o: any) {
    if (n) {
      //开
      this.exam.testExamId = this.exam.testExamId
        ? this.exam.testExamId
        : this.testExamList?.[0]?.id;
    } else {
      this.exam.testExamId = 0;
    }
  }
  //身份证后六位 固定在第三项
  id6AtThird(n: Param[], o: any) {
    const i = n.findIndex(d => d.inputType === "shortIdCard");
    if (i !== -1) {
      const item = this.RegisSelectedList[i];
      this.RegisSelectedList.splice(i, 1);
      this.RegisSelectedList.splice(2, 0, item);
    }
  }

  // 防作弊开启关闭赋默认值
  setCheat(value: number) {
    if (value === 1) {
      // 开启
      this.exam.screenshotCheck = this.exam.mobileJoinCountCheck = 1;
      this.exam.screenshotCheckLimit = this.exam.mobileJoinCountCheckLimit = 2;
    } else {
      this.exam.screenshotCheck = this.exam.mobileJoinCountCheck = 2;
      this.exam.screenshotCheckLimit = this.exam.mobileJoinCountCheckLimit = 0;
    }
  }

  // 人脸核验，选择其他时初始化 人脸核验(H5页面完成人脸核验) 的值。
  onLivenessRecognitionFaceVerifyInit() {
    if (this.examv3.settingInformation.preventionCheatConfig.lrType !== 6) {
      this.examv3.settingInformation.preventionCheatConfig
        .lrRetryNumberLimit === 0;
      this.examv3.settingInformation.preventionCheatConfig.lrErrorAutoSubmit ===
        1;
    }
  }

  //切换限制时间
  changTimeLimit(n: any) {
    if (n === 1) {
      //24h
      this.exam.timeLimitExam = 0;
      // this.timeLimitExam = 0;
    } else if (n == 3) {
      // this.showTimeChange();
    } else {
      //自定义分钟数
    }
  }

  //限制次数的时间区间
  @Watch("exam.repeatAnswerDayLimit", { deep: true, immediate: true })
  timeLimitRule(n: any, o: any) {
    if (n) {
      this.exam.repeatAnswerDayLimit =
        Number(n) < 1 ? 1 : Number(n) > 365 ? 365 : Number(n);
    }
  }
  defaultBG =
    "https://oss.hina.com/app/hina/2021/07/10/3f1396a2ddd6a8493c582f22c69dae39.png";
  virHrBG =
    "https://oss.hina.com/app/test/2023/04/27/cfa4e88884322bba78d8a445d52b59ac.png";
  // "https://oss.hina.com/app/test/2023/04/27/4e1887e0ceeac997ef35c0b63ae34f42.png";
  radio1 = 0;
  radio2 = 1;
  ttt = "";
  upImgUrl: any = {};
  useDiyImg = 0; //使用默认图片封面
  RegisList: Param[] = []; //所有字段list
  RegisSelectedList: Param[] = []; //已选字段list
  showRegis = false; //弹窗 -字段
  editParam: any; //编辑体
  videoUrl = ""; //宣传页 宣传视频 自定义视频url
  videoUrlDef =
    "https://vod.hina.com/a3309d04251940faa56806be59bdf122/8c7be05066f64d29ae74ffbd5500daa9-ca173c7e0f3241eb8285dedda051a1ba-ld.mp4"; //视频预览url默认
  textDef1 =
    "海纳隶属于北京群星闪耀科技有限公司，致力于以AI技术赋能人力资源行业，帮助千千万万人才和企业做好人岗匹配、提升组织效率。拥有雄厚资本支持，可保证团队投入大量资金和人力到产品研发上，持续提升AI及产品能力，为大型集团提供可靠、持久的杰出服务。";
  textDef2 =
    "你好，我是本次面试的面试官，欢迎参加本公司的线上面试！面试预计需要10分钟，请你提前安排在网络良好、光线亮度合适、且相对安静的环境参加这次面试，以免影响本次面试的结果。如果你在面试过程中遇到问题，请与我们的招聘人员联系。";
  textDef3 =
    "感谢你参加面试，面试结果我们会在1-3个工作日内通知你。我们期待你的加入，再见！";
  repeatLimit = false;
  repeatLimitShow = 1; //限制面试次数 下拉展示用
  useTestExam = 0; //模拟练习 开关
  // timeLimitExamType = 1; //考试时间限制类型
  // timeLimitExam = 0; //时长
  testExamList: TestExamList[] = [new TestExamList()];
  dataReady = false;
  RegisSelectedBehindList: Param[] = []; //已选靠后字段
  RegisSelectedFrontendList: Param[] = []; //已选字段list
  showBehindList = false; // 面试后登记信息开关
  collapseInd = 0;
  isZMNCompany = false;

  startLoading() {
    this.dataReady = false;
    this.status();
  }
  endLoading() {
    this.dataReady = true;
    this.status();
  }
  //提交前校验
  async checkData() {
    // //非空
    if (!this.examv3.settingInformation.timeConfig.beginTime) {
      this.$message.warning("请选择面试开始时间");
      return false;
    }
    //非长期有效 或 统一面试  需要选择结束时间
    if (
      (this.examv3.settingInformation.timeConfig.noEnding !== 1 ||
        this.examv3.settingInformation.timeConfig.examBeginTogether === 1) &&
      !this.examv3.settingInformation.timeConfig.endTime
    ) {
      this.$message.warning("请选择面试结束时间");
      return false;
    }
    //结束时间不能早于开始时间
    if (
      this.examv3.settingInformation.timeConfig.endTime &&
      this.examv3.settingInformation.timeConfig.beginTime
    ) {
      if (
        this.examv3.settingInformation.timeConfig.endTime <
        this.examv3.settingInformation.timeConfig.beginTime
      ) {
        this.$message.warning("面试结束时间不能早于开始时间");
        return false;
      }
    }
    //统一开考 时
    if (
      this.examv3.settingInformation.timeConfig.examBeginTogether === 1 &&
      !this.examv3.settingInformation.timeConfig.examRegisterEndTime
    ) {
      this.$message.warning("请选择登记截止时间");
      return false;
    }
    //截止时间要介于起止时间之间
    if (
      this.examv3.settingInformation.timeConfig.examBeginTogether === 1 &&
      this.examv3.settingInformation.timeConfig.endTime &&
      this.examv3.settingInformation.timeConfig.beginTime
    ) {
      if (
        this.examv3.settingInformation.timeConfig.examRegisterEndTime <
          this.examv3.settingInformation.timeConfig.beginTime ||
        this.examv3.settingInformation.timeConfig.examRegisterEndTime >
          this.examv3.settingInformation.timeConfig.endTime
      ) {
        this.$message.warning("登记截止时间要介于面试开始时间和结束时间之间");
        return false;
      }
    }
    //文案非空
    if (!this.examv3.settingInformation.publicityPage.publicityPageContent) {
      this.$message.warning("请填写宣传页展示文案");
      return false;
    }
    if (!this.examv3.settingInformation.publicityPage.descBefore) {
      this.$message.warning("请填写须知页展示文案");
      return false;
    }
    if (!this.examv3.settingInformation.publicityPage.descAfter) {
      this.$message.warning("请填写结束页展示文案");
      return false;
    }
    //图片非空
    if (
      !this.examv3.settingInformation.publicityPage.publicityPageVideoCoverUrl
    ) {
      this.$message.warning("请上传宣传页封面");
      return false;
    }
    if (!this.examv3.settingInformation.publicityPage.descBeforeShowWayImgUrl) {
      this.$message.warning("请上传须知页展示背景");
      return false;
    }
    if (!this.examv3.settingInformation.publicityPage.descAfterShowWayImgUrl) {
      this.$message.warning("请上传结束页展示背景");
      return false;
    }
    //视频非空
    if (
      this.examv3.settingInformation.publicityPage
        .publicityPageVideoUseWhich !== 0 &&
      !this.examv3.settingInformation.publicityPage.publicityPageVideoUrl
    ) {
      this.$message.warning("请上传宣传页视频");
      return false;
    }
    if (this.examv3.settingInformation.timeConfig.examBeginTogether !== 1) {
      this.examv3.settingInformation.timeConfig.examRegisterEndTime = "";
    }

    //后端格式转换
    this.setSeconed();
    return true;
  }

  @Emit()
  status() {
    return this.dataReady;
  }

  // 心理相关题目处理
  initSelectedPsyc(psychologicalMotivation: PsychologicalMotivation) {
    const { psyc1, psyc4 } = psychologicalMotivation;

    if (psyc1.use === 1) {
      const psycId = psycGaugeIdMap[Check.BIG_FIVE_240];
      const mindObj =
        this.mindList.find(item => item.psycGaugeId === psycId) ||
        new PsycGaugeConfig();

      psyc1.psycGaugeSubDimensionList = mindObj.dimensionList.reduce(
        (pre: any[], item) => {
          const list = item.subDimensionList
            .filter(sItem =>
              psyc1.psycGaugeSubDimensionIdList.includes(
                sItem.psycGaugeDimensionId
              )
            )
            .map(sItem => ({
              id: sItem.psycGaugeDimensionId,
              questionCount: sItem.questionCount
            }));

          return [...pre, ...list];
        },
        []
      );
    }

    if (psyc4.use === 1) {
      const psycId = psycGaugeIdMap[Check.BIG_FIVE_60];
      const mindObj =
        this.mindList.find(item => item.psycGaugeId === psycId) ||
        new PsycGaugeConfig();

      psyc4.psycGaugeSubDimensionList = mindObj.dimensionList
        .filter(item =>
          psyc4.psycGaugeSubDimensionIdList.includes(item.psycGaugeDimensionId)
        )
        .map(item => ({
          id: item.psycGaugeDimensionId,
          questionCount: item.questionCount
        }));
    }
  }

  created() {
    this.status();
    //获取公司所有字段
    RegisInfo.getAll(Auth.companyId).then(res => {
      res.paramList.forEach((d: any) => {
        //新增时 选项存入个随机id
        for (let i = 0; i < d.singleChoiceOptions.length; i++) {
          d.fIdList.push(this.R());
        }
      });
      //首次直接扔缓存里，后续只与缓存io
      this.examv3.settingInformation.paramList =
        this.examv3.settingInformation.paramList.length > 1
          ? this.examv3.settingInformation.paramList
          : res.paramList;
      // this.RegisList = this.exam.paramList; //全部
      this.RegisList = this.examv3.settingInformation.paramList; //全部
      //已选 排序
      this.RegisSelectedList = this.RegisList.filter(res => {
        return res.isShow === 1;
      }).sort((a: Param, b: Param) => {
        return Number(a.sort) - Number(b.sort);
      });
      this.RegisSelectedList.forEach(el => {
        if (el.saveLater === 0 || !el.saveLater) {
          this.RegisSelectedFrontendList.push(el);
        }
        if (el.saveLater === 1) {
          this.RegisSelectedBehindList.push(el);
        }
      });
      // 判断是否为啄木鸟门店
      const companyConfig: any = JSON.parse(
        localStorage.getItem("ConfigCache_company_config") ?? ""
      );
      const key: any = this.$route.query.companyId ?? null;
      this.isZMNCompany = companyConfig[key]?.isCompanyZmn === 1;
      if (this.isZMNCompany) {
        let item = new Param();
        let itemBehind = new Param();
        const list = this.RegisSelectedFrontendList.filter(el => {
          return el.name === "身份证号" || el.name === "身份证号后6位";
        });
        this.examv3.settingInformation.paramList.forEach(el => {
          if (el.name === "啄木鸟门店-选择地址") {
            item = el;
          }
          if (el.name === "啄木鸟门店-选择门店") {
            itemBehind = el;
          }
        });
        if (item.name) {
          if (list.length === 2) {
            item.sort = 5;
            this.RegisSelectedFrontendList.splice(4, 0, item);
          } else if (list.length === 1) {
            item.sort = 4;
            this.RegisSelectedFrontendList.splice(3, 0, item);
          } else {
            item.sort = 3;
            this.RegisSelectedFrontendList.splice(2, 0, item);
          }
        }
        if (itemBehind.name) {
          this.RegisSelectedBehindList.unshift(itemBehind);
        }
        this.$forceUpdate();
      }
      if (this.RegisSelectedBehindList.length > 0) {
        this.showBehindList = true;
      }
      this.setDefVir();
      this.dataReady = true;
      this.setSwitch();
      this.status();
    });
  }

  mounted() {
    //新建
    if (!this.isEdit) {
      //时间初始化
      //开始时间
      if (!this.examv3.settingInformation.timeConfig.beginTime) {
        //取值当前时间
        this.examv3.settingInformation.timeConfig.beginTime = moment().format(
          "YYYY-MM-DD HH:mm:ss"
        );
      }
      //须知语 预计耗时 --用户修改过就不覆盖
      if (this.isDefDescBeforeText) {
        this.setDefText("descBefore");
      }
    } else {
      //编辑
      this.initSelectedPsyc(
        this.examv3.processInformation.psychologicalMotivation
      );
    }
    if (!this.examv3.settingInformation.publicityPage.publicityPageVideoUrl) {
      this.examv3.settingInformation.publicityPage.publicityPageVideoUrl = this.videoUrlDef;
    } else {
      this.videoUrl = this.examv3.settingInformation.publicityPage.publicityPageVideoUrl;
    }
    this.getTestExam(); //模拟练习
    this.setData();
    this.setScroll();
  }
  setScroll() {
    const card = document.getElementById("main-card") as HTMLElement;
    if (card) {
      card.addEventListener("scroll", this.scrollEvent);
    } else {
      setTimeout(() => {
        this.setScroll();
      }, 100);
    }
  }
  beforeDestroy() {
    const card = document.getElementById("main-card") as HTMLElement;
    if (card) {
      card.removeEventListener("scroll", this.scrollEvent);
    }
  }
  //是否选择题
  isSelectTypeQuestion(id: number): boolean {
    const QConfig = this.exam.examScoreConfigList.filter(q => {
      return q.questionId === id;
    });
    return Boolean(QConfig?.[0]?.choiceQuestionScoreList?.[0]?.content);
  }

  //是否填空题
  isBlankTypeQuestion(id: number): boolean {
    const QConfig = this.exam.examScoreConfigList.filter(q => {
      return q.questionId === id;
    });
    return Boolean(QConfig?.[0]?.blankQuestionScoreList[0]);
  }

  //面试预计耗时
  get examTakeTime() {
    let second = 0;
    if (this.exam.isRandomQuestions === 1) {
      // 抽题组卷
      this.exam.examRandomConfigList.forEach((questionGroup, index) => {
        // 抽题组卷根据每组配置的题目类型与抽题数量算时长
        const n = questionGroup.questionNumber;
        if (
          questionGroup.questionType === 1 ||
          questionGroup.questionType === 5
        ) {
          //选择填空题耗时  30s
          second += n * 30;
        } else {
          // 视频音频 同普通
          second += n * 30;
          second +=
            questionGroup.examQuestionConfig?.preparationTime > 0
              ? questionGroup.examQuestionConfig?.preparationTime
              : n * 10;
          second +=
            questionGroup.examQuestionConfig?.answerTime > 0
              ? questionGroup.examQuestionConfig?.answerTime
              : n * 3 * 60;
        }
      });
    } else {
      this.exam.examQuestionConfigList.forEach((q, i: number) => {
        if (
          this.isSelectTypeQuestion(q.questionId) ||
          this.isBlankTypeQuestion(q.questionId)
        ) {
          //选择题/填空题耗时  30s
          second += 1 * 30;
        } else {
          //视频题耗时  题干30s 其他看配置
          second += 1 * 30;
          second += q?.preparationTime > 0 ? q?.preparationTime : 1 * 10;
          second += q?.answerTime > 0 ? q?.answerTime : 3 * 60;
        }
      });
    }
    //各类配置耗时
    second += this.exam.colorTest === 1 ? 1 * 60 : 0;
    second += this.exam.psycGaugeConfig.psycGaugeId !== 0 ? 5 * 60 : 0;
    second += this.exam.gameTestConfig[0] !== 0 ? 1 * 60 : 0;
    second += this.exam.fingerTest === 1 ? 1 * 60 : 0;
    second += this.exam.bgCheckProductId !== 0 ? 1 * 10 : 0;
    second +=
      this.examv3.settingInformation.preventionCheatConfig
        .livenessRecognition === 1
        ? 1 * 60
        : 0;
    const minutes = Math.ceil(second / 60);
    return minutes;
  }
  //视频是否解码完成
  get videoReady() {
    return (
      this.exam.publicityPageVideoUseWhich === 2 &&
      this.exam.publicityPageVideoUrl
    );
  }

  //计算长度
  get ww() {
    const t: any = this.testExamList.find(d => d.id === this.exam.testExamId);
    return (t?.name?.length ?? 5) * 14 + 55;
  }
  //选项ID生成
  R() {
    return String((Math.random() * 10000000000).toFixed(0));
  }

  //exam回显数据
  setData() {
    //********封面 图片默认值
    if (
      this.examv3.settingInformation.publicityPage.publicityPageImgUseWhich ===
      1
    ) {
      this.examv3.settingInformation.publicityPage.publicityPageVideoCoverUrl = this.defaultBG;
    }
    //******须知语
    if (this.examv3.settingInformation.publicityPage.descBeforeShowWay === 0) {
      //虚拟面试官
      this.examv3.settingInformation.publicityPage.descBeforeShowWayImgUrl = this.getVirImg;
    }
    if (this.examv3.settingInformation.publicityPage.descBeforeShowWay === 1) {
      //默认
      this.examv3.settingInformation.publicityPage.descBeforeShowWayImgUrl = this.defaultBG;
    }
    if (this.examv3.settingInformation.publicityPage.descBeforeShowWay === 2) {
      //自定义
      this.upImgUrl.descBeforeShowWayImgUrl =
        this.examv3.settingInformation?.publicityPage
          ?.descBeforeShowWayImgUrl || "";
    }
    //********结束语
    if (this.examv3.settingInformation.publicityPage.descAfterShowWay === 0) {
      //虚拟面试官
      this.examv3.settingInformation.publicityPage.descAfterShowWayImgUrl = this.getVirImg;
    }
    if (this.examv3.settingInformation.publicityPage.descAfterShowWay === 1) {
      //默认
      this.examv3.settingInformation.publicityPage.descAfterShowWayImgUrl = this.defaultBG;
    }
    if (this.examv3.settingInformation.publicityPage.descAfterShowWay === 2) {
      //自定义
      this.upImgUrl.descAfterShowWayImgUrl =
        this.examv3.settingInformation?.publicityPage?.descAfterShowWayImgUrl ||
        "";
    }

    //限制面试次数
    // const isLimit = this.exam.repeatAnswerLimit !== 100;
    // this.repeatLimit = isLimit ? true : false;
    // this.repeatLimitShow = isLimit ? this.exam.repeatAnswerLimit : 1;
    //模拟练习
    // this.useTestExam = this.exam.testExamId !== 0 ? 1 : 0;
    //答题时间限制
    // this.timeLimitExamType = this.exam.timeLimitExam === 86400 ? 1 : 2;
    // this.exam.timeLimitExam =
    //   this.exam.timeLimitExam === 86400
    //     ? 0
    //     : this.isEdit
    //     ? this.exam.timeLimitExam / 60
    //     : this.exam.timeLimitExam; //默认 或 秒转分
  }

  //短信验证码
  setMessage() {
    if (
      (this.examv3.processInformation.jobMatching.identityInfo === 1 ||
        this.examv3.processInformation.jobMatching.socialInfo === 1 ||
        this.examv3.processInformation.jobMatching.financialRisk === 1) &&
      this.examv3.settingInformation.captchaCheck === 1
    ) {
      this.$message.warning("背调服务已开启，需短信验证码校验候选人手机号");
      return;
    }
    this.examv3.settingInformation.captchaCheck =
      this.examv3.settingInformation.captchaCheck === 1 ? 2 : 1;
    this.change();
  }
  //已选字段排序sort
  sortSelected() {
    this.RegisSelectedList.forEach((d, i) => {
      d.sort = i + 1;
    });

    this.exam.paramList = this.RegisList;
    this.change();
  }
  frontAdd() {
    this.RegisSelectedFrontendList.forEach(el => {
      el.saveLater = 0;
    });
    this.sortFrontSelected();
  }
  behindAdd() {
    this.RegisSelectedBehindList.forEach(d => {
      d.saveLater = 1;
    });
    this.sortBehindSelected();
  }
  timeLimitGiveUpChange(value: any) {
    if (value === -1) {
      this.exam.giveUpNotSignIn = 2;
      this.exam.giveUpSignIn = 2;
    } else {
      this.exam.giveUpNotSignIn = 1;
      this.exam.giveUpSignIn = 1;
    }
  }
  giveUpSignInChange(value: number, key: string) {
    if (value !== 1) {
      this.exam[key] = 1;
    }
  }
  sortBehindSelected() {
    this.RegisSelectedList = [
      ...this.RegisSelectedFrontendList,
      ...this.RegisSelectedBehindList
    ];
    this.RegisSelectedList.forEach((d, i) => {
      d.sort = i + 1;
    });
    this.exam.paramList = this.RegisList;
    this.change();
  }
  sortFrontSelected() {
    this.RegisSelectedList = [
      ...this.RegisSelectedFrontendList,
      ...this.RegisSelectedBehindList
    ];
    this.RegisSelectedList.forEach((d, i) => {
      d.sort = i + 1;
    });
    this.exam.paramList = this.RegisList;
    this.change();
  }
  //模拟练习
  getTestExam() {
    ExamList.getTestExams().then(res => {
      if (res.code === 0) {
        if (res.data.length) {
          this.testExamList = res.data;
          if (this.useTestExam) {
            this.exam.testExamId = this.exam.testExamId
              ? this.exam.testExamId
              : res.data?.[0]?.id;
          } else {
            this.exam.testExamId = 0;
          }
        }
      }
    });
  }
  //登记信息 下拉框内可用的字段
  getSeletOptions(type: number) {
    let list = this.RegisList.filter(
      el => el.saveLater == type && el.inputType !== "zmnStore"
    );
    list.filter(el => {
      return el.name !== "姓名" && el.name !== "手机";
    });
    //过滤已选的
    if (type === 0) {
      list = list.filter(el => {
        return !this.RegisSelectedFrontendList.find(d => d.name === el.name);
      });
    } else {
      list = list.filter(el => {
        return !this.RegisSelectedBehindList.find(d => d.name === el.name);
      });
    }

    return list;
  }
  //模拟选择
  selectItem(name: string) {
    this.some = "请选择";
    const item = this.RegisSelectedList.find(d => d.name === name);
    if (item) {
      this.select(item);
    }
  }
  //选择
  select(item: Param) {
    const i = this.RegisSelectedList.findIndex(
      (d: Param) => d.name === item.name
    );
    item.isShow = item.isShow === 1 ? 2 : 1;
    if (i !== -1) {
      //取消
      this.RegisSelectedList.splice(i, 1);
      this.$forceUpdate();
    } else {
      //选中
      if (item.inputType !== "shortIdCard" && item.inputType !== "idcard") {
        this.RegisSelectedList.push(item);
        this.$forceUpdate();
      } else {
        const i = this.RegisSelectedList.findIndex(
          d => d.inputType === "shortIdCard"
        );
        if (i == -1 && item.inputType === "idcard") {
          this.RegisSelectedList.splice(2, 0, item);
        } else {
          enum num {
            "shortIdCard" = 2,
            "idcard" = 3
          }
          //身份后六 固定第三
          this.RegisSelectedList.splice(num[item.inputType], 0, item);
          this.$forceUpdate();
        }
      }
    }
    this.updateTowList();
    this.sortSelected();
    this.$forceUpdate();
  }
  updateTowList() {
    this.RegisSelectedFrontendList = [];
    this.RegisSelectedBehindList = [];
    this.RegisSelectedList.forEach(el => {
      if (el.saveLater === 0 || !el.saveLater) {
        this.RegisSelectedFrontendList.push(el);
      }
      if (el.saveLater === 1) {
        this.RegisSelectedBehindList.push(el);
      }
    });
    this.$forceUpdate();
  }
  addRegis(saveLater?: boolean) {
    this.editParam = undefined;
    this.showRegis = true;
    if (saveLater) {
      this.$nextTick(() => {
        const RegisEdit = this.$refs.RegisEdit as any;
        RegisEdit.formData.saveLater = 1;
      });
    }
  }

  showBehindListChange(value: any) {
    if (value && !this.RegisSelectedBehindList.length) {
      this.collapseInd = 1;
    }
  }

  editRegis(item: Param) {
    this.editParam = item;
    this.showRegis = true;
  }
  //字段确认  params:更新后数据   edit:更新前数据
  editOk(params: Param, edit: any) {
    const n = this.RegisList.find(d => d.name === params.name);
    if (n && n?.paramIndex !== params.paramIndex) {
      this.$message.warning("字段名称不能重复");
      return;
    }
    if (edit) {
      //编辑
      this.RegisList.splice(Number(edit.paramIndex) - 1, 1, params);
      const i = this.RegisSelectedList.findIndex(
        d => d.paramIndex === edit.paramIndex
      );
      if (i !== -1) {
        this.RegisSelectedList.splice(i, 1, params);
      }
    } else {
      //新增
      params.paramIndex = this.RegisList.length + 1;
      params.isShow = 1;
      this.RegisList.push(params);
      // this.select(params)
      this.RegisSelectedList.push(params); //直接选中
      this.sortSelected();
    }
    this.exam.paramList = this.RegisList;
    this.updateTowList();
    this.change();
    this.showRegis = false;
  }
  editClose() {
    this.showRegis = false;
  }
  //根据测评配置，设置对应字段
  setSwitch() {
    //人脸开启 跟随选中身份证字段
    if (
      this.examv3.settingInformation.preventionCheatConfig
        .livenessRecognition === 1
    ) {
      this.setIdCard(1);
    }
    //使用背调  开启身份证 和 验证码
    this.setIdCardAndPhoneMessage();
  }
  //人脸开启 跟随选中身份证字段
  setIdCard(e: any) {
    if (e !== 1) return;
    const i = this.RegisList.findIndex(d => d.name === "身份证号");
    if (i !== -1 && this.RegisList[i].isShow !== 1) {
      this.RegisList[i].isRequired = 1;
      this.select(this.RegisList[i]);
    }
  }
  //使用背调  开启身份证 和 验证码
  setIdCardAndPhoneMessage() {
    if (
      this.examv3.processInformation.jobMatching.identityInfo === 1 ||
      this.examv3.processInformation.jobMatching.socialInfo === 1 ||
      this.examv3.processInformation.jobMatching.financialRisk === 1
    ) {
      this.setIdCard(1);
      this.examv3.settingInformation.captchaCheck = 1;
      this.change();
    }
  }
  //切屏
  playPhoneTo(i: number) {
    (this.$refs.carousel1 as any)?.setActiveItem(i);
  }

  // 防截屏限制
  setScreenshot(value: string, operate: string) {
    this.examv3.settingInformation.preventionCheatConfig.screenshotCheckLimit = Number(
      value
    );

    if (Number(value) === 1) {
      this.examv3.settingInformation.preventionCheatConfig.screenshotCheckLimit =
        operate !== "up" ? 0 : 2;
    }

    this.change();
  }

  // 防切屏限制
  setMobileJoin(value: string, operate: string) {
    this.examv3.settingInformation.preventionCheatConfig.mobileJoinCountCheckLimit = Number(
      value
    );

    if (Number(value) === 1) {
      this.examv3.settingInformation.preventionCheatConfig.mobileJoinCountCheckLimit =
        operate !== "up" ? 0 : 2;
    }

    this.change();
  }

  //上传图片
  uploaded(d: any, attr: string, index: number) {
    //切换用的缓存
    this.upImgUrl[attr] = d;
    this.examv3.settingInformation.publicityPage[attr] = d;
    this.playPhoneTo(index);
    if (
      index === 1 &&
      this.examv3.settingInformation.publicityPage.descAfterShowWayIsSame === 1
    ) {
      this.setSame();
    }
    this.change();
    //
  }

  // //上传须知语图片
  // uploadedBeforeImg(d: any) {
  //   this.exam.descBeforeShowWayImgUrl = d;
  //   (this.$refs.carousel2 as any)?.setActiveItem(0);
  //   this.change();
  // }
  // //上传结束语图片
  // uploadedAfterImg(d: any) {
  //   this.exam.descAfterShowWayImgUrl = d;
  //   (this.$refs.carousel2 as any)?.setActiveItem(1);
  //   this.change();
  // }

  //上传成功后 视频url
  setVideoUrl(url: string) {
    this.examv3.settingInformation.publicityPage.publicityPageVideoUrl = url;
    this.videoUrl = url;
    this.change();
  }
  // 时间设置变化
  noEndingChange(label: number) {
    // if (label !== 1) {
    //   this.showPopMessage =
    //     "当前答题时间限制为固定期限范围内,如需修改请设置面试时间的其他选项";
    // } else {
    //   this.showPopMessage = "此面试有效期为长期有效，无法设置此选项";
    // }
  }

  //切屏
  prev(i: number) {
    (this.$refs["carousel" + i] as any)?.prev();
  }
  next(i: number) {
    (this.$refs["carousel" + i] as any)?.next();
  }
  //拖
  onMove() {
    //
  }

  @Emit()
  change() {
    return;
  }
  //是否条件字段
  showOp(item: any) {
    return item?.showConfigList?.[0]?.[0]?.matchParamIndex;
  }
  //条件展示文案
  showOpText(item: any) {
    const fa = this.RegisList.find((d: any) => {
      return d.paramIndex == item.showConfigList?.[0]?.[0]?.matchParamIndex;
    });
    let t = ``;
    fa?.fIdList.forEach((d: any, i: number) => {
      item.showConfigList.forEach((m: any, n: number) => {
        if (d == m[0].fId) {
          t += `[${fa.singleChoiceOptions[i] || fa.mutiChoiceOptions[i].key}] `;
        }
      });
    });
    return { name: fa?.name, text: t };
  }
  openInviteWarning() {
    if (this.hasWarnOpenJoin || !this.usePublicCodeWhiteList || !this.isEdit)
      return;
    this.showWarnDialog = true;
  }
  handleCloseWarn() {
    this.showWarnDialog = false;
    this.hasWarnOpenJoin = true;
  }
  //检查图片视频的宽高比例
  async checkoutMediaWidthHeight(it: BeforeVideo, index: number) {
    if (it.showWay === 4 && it.videoCoverUrl) {
      //图片
      return new Promise((resolve, reject) => {
        const img = document.createElement("img");
        img.onload = () => {
          //
          const width = img.width;
          const height = img.height;
          // this.exam.examVideoList[index].fillType = width > height ? 0 : 1;
          this.$set(
            this.exam.examVideoList[index],
            "fillType",
            width > height ? 0 : 1
          );
          this.change();
          resolve(true);
        };
        img.src = it.videoCoverUrl;
      });
    } else {
      //视频在上传时已处理
      return;
    }
  }
}
